import React from 'react';
import cn from 'classnames';
import { XIcon } from '@phosphor-icons/react';

export interface MPFFilterPillProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  label: string;
  selected?: boolean;
  showRemoveIcon?: boolean;
  onToggle?: (selected: boolean) => void;
}

// No Figma o "x" é um botão dentro da pill, que também é botão — inválido em
// HTML e inalcançável pelo teclado. Aqui a pill inteira é um `<button>` e o
// "x" é decorativo: clicar em qualquer ponto alterna.
export const MPFFilterPill: React.FC<MPFFilterPillProps> = ({
  label,
  selected = false,
  showRemoveIcon,
  onToggle,
  className,
  ...rest
}) => {
  const withRemoveIcon = showRemoveIcon ?? selected;

  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={() => onToggle?.(!selected)}
      className={cn(
        'mpf-filter-pill',
        selected ? 'mpf-filter-pill--selected' : 'mpf-filter-pill--enabled',
        className,
      )}
      {...rest}
    >
      {label}
      {withRemoveIcon && (
        <XIcon className="mpf-filter-pill__icon" aria-hidden="true" />
      )}
    </button>
  );
};

export default MPFFilterPill;
